// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_0d624b9a27--tooltip--Jsh1z","arrow_tooltip":"_0d624b9a27--arrow_tooltip--SRU9V","arrow":"_0d624b9a27--arrow--A4pue"};